/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_No_PermissionInputs */

const en_admin_dashboard_no_permission = /** @type {(inputs: Admin_Dashboard_No_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You don't have permission to access this data.`)
};

const fr_admin_dashboard_no_permission = /** @type {(inputs: Admin_Dashboard_No_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous n'avez pas l'autorisation d'accéder à ces données.`)
};

const nl_admin_dashboard_no_permission = /** @type {(inputs: Admin_Dashboard_No_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je hebt geen toestemming om deze gegevens te bekijken.`)
};

const ro_admin_dashboard_no_permission = /** @type {(inputs: Admin_Dashboard_No_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu aveti permisiunea de a accesa aceste date.`)
};

/** @type {(inputs: Admin_Dashboard_No_PermissionInputs) => LocalizedString} */
const de_admin_dashboard_no_permission = en_admin_dashboard_no_permission;

/** @type {(inputs: Admin_Dashboard_No_PermissionInputs) => LocalizedString} */
const es_admin_dashboard_no_permission = en_admin_dashboard_no_permission;

/** @type {(inputs: Admin_Dashboard_No_PermissionInputs) => LocalizedString} */
const it_admin_dashboard_no_permission = en_admin_dashboard_no_permission;

/** @type {(inputs: Admin_Dashboard_No_PermissionInputs) => LocalizedString} */
const pt_br2_admin_dashboard_no_permission = en_admin_dashboard_no_permission;

/** @type {(inputs: Admin_Dashboard_No_PermissionInputs) => LocalizedString} */
const pl_admin_dashboard_no_permission = en_admin_dashboard_no_permission;

/** @type {(inputs: Admin_Dashboard_No_PermissionInputs) => LocalizedString} */
const hu_admin_dashboard_no_permission = en_admin_dashboard_no_permission;

/**
* | output |
* | --- |
* | "You don't have permission to access this data." |
*
* @param {Admin_Dashboard_No_PermissionInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_no_permission = /** @type {((inputs?: Admin_Dashboard_No_PermissionInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_No_PermissionInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_no_permission(inputs)
	if (locale === "de") return de_admin_dashboard_no_permission(inputs)
	if (locale === "es") return es_admin_dashboard_no_permission(inputs)
	if (locale === "fr") return fr_admin_dashboard_no_permission(inputs)
	if (locale === "nl") return nl_admin_dashboard_no_permission(inputs)
	if (locale === "it") return it_admin_dashboard_no_permission(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_no_permission(inputs)
	if (locale === "pl") return pl_admin_dashboard_no_permission(inputs)
	if (locale === "hu") return hu_admin_dashboard_no_permission(inputs)
	return ro_admin_dashboard_no_permission(inputs)
});
export { admin_dashboard_no_permission as "admin.dashboard.no_permission" }